module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="content">\n    <header>\n        <i class="fal fa-exclamation-circle"></i>\n        <div class="main-heading">' +
((__t = ( data.name )) == null ? '' : __t) +
' is on ' +
((__t = ( data.currentPackageName )) == null ? '' : __t) +
' </div>\n        <div class="sub-heading">But, you have the option to demo the account using\n            ';
 if (data.currentPackageName.toLowerCase() === "lite") { ;
__p += '\n            <span>Pro</span>\n            ';
 } else { ;
__p += '\n            <span>Lite</span>\n            ';
 } ;
__p += '\n        </div>\n    </header>\n    <div class="buttons">\n        ';
 if (data.currentPackageName.toLowerCase() === "lite") { ;
__p += '\n        <button class="btn lite active-btn">Continue to Lite</button>\n        ';
 } else { ;
__p += '\n        <button class="btn lite">Demo Lite</button>\n        ';
 } ;
__p += '\n\n        ';
 if (data.currentPackageName.toLowerCase() === "pro") { ;
__p += '\n        <button class="btn pro active-btn">Continue to Pro</button>\n        ';
 } else { ;
__p += '\n        <button class="btn pro">Demo Pro</button>\n        ';
 } ;
__p += '\n\n        <button class="btn all">Pro + Add-ons</button>\n    </div>\n</div>\n';
return __p
}